import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=7988e47d&scoped=true&"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDetails.vue?vue&type=style&index=0&id=7988e47d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988e47d",
  null
  
)

export default component.exports